import React from 'react';

const styles = {
  Card: {
    top: '0px',
    left: '0px',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'rgba(255,255,255,0.96)',
    border: '1px solid var(--brand-border, #f0f0f0)',
    boxSizing: 'border-box',
  },
};

const Card = (props) => {
  return <div style={styles.Card}>{props.children}</div>;
};

export default Card;
